import React from 'react'
import { Modal, Header, Button, Icon, Confirm, Message } from 'semantic-ui-react'
import { isEmpty,isEqual, isNull, get, isUndefined} from "lodash";
class StatementModal extends React.Component {
  constructor(props){
  super();
    this.state = { 
      open: true,
    }
  }
  open = () => this.setState({ open: true })
  close = () => {
    this.setState({ open: false })
    this.props.changeStateModal()
  }
  submitClicked = () => {
    this.setState({ open: false })
    this.close()
    this.props.submitClicked()
  }
  
  
  render() {
    let { archivedLineItem, validLineItem} = this.props;
    return (
        <Confirm
          open={this.state.open}
          content= {<div style={{padding:'2rem'}}>Are you sure you want to proceed?
          <br/>{validLineItem.length?`${validLineItem.length} valid item${validLineItem.length==1?'':'s'}`:''}
          <br/>{archivedLineItem.length?`${archivedLineItem.length} archived item${archivedLineItem.length==1?'':'s'}`:''}
          </div>}
          cancelButton="No"
          confirmButton="Yes"
          onCancel={this.close}
          onConfirm={this.submitClicked}
        />
    )
  }
}

export default StatementModal